<template>
  <b-row>
    <b-col md="4">
      <label>Tipo de venta*</label>
    </b-col>
    <b-col md="8">
      <b-form-select v-model="oferta.tipoVenta" :disabled="disabled">
        <b-form-select-option disabled selected value=""> Seleccione el tipo de venta </b-form-select-option>
        <b-form-select-option v-for="tv in tiposDeVenta" :key="tv.id" :value="tv.id">
          {{ tv.nombre }}
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import * as TipoVenta from "@/enums/TipoVenta";
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta"]),
    tiposDeVenta() {
      return TipoVenta.combo;
    },
  },
};
</script>
